var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-tag"},[(_vm.hasPoint)?_c('i',{staticClass:"point"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }